/* WoodBuzz Home Interiors — vanilla JS
   Handles: sticky header, mobile nav, hero parallax, scroll reveals,
   before/after slider, animated counters, portfolio filter,
   modal popup (open on all CTAs), multi-step lead form, exit-intent. */

/* ============ SVG Icon Injector ============ */
(function(){
  var ICONS = {
    'sparkles': '<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>',
    'phone': '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>',
    'phone-call': '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/><path d="M14.05 2a9 9 0 0 1 8 7.94"/><path d="M14.05 6A5 5 0 0 1 18 10"/>',
    'arrow-right': '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    'arrow-left': '<path d="M19 12H5"/><path d="m12 19-7-7 7-7"/>',
    'arrow-up-right': '<path d="M7 7h10v10"/><path d="M7 17 17 7"/>',
    'play': '<polygon points="6 3 20 12 6 21 6 3" fill="currentColor" stroke="none"/>',
    'calendar': '<path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/>',
    'pen': '<path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/>',
    'factory': '<path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M17 18h1"/><path d="M12 18h1"/><path d="M7 18h1"/>',
    'layers': '<path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/><path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"/><path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"/>',
    'wrench': '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>',
    'shield': '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67 0C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>',
    'ruler': '<path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.4 2.4 0 0 1 0-3.4l2.6-2.6a2.4 2.4 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/>',
    'boxes': '<path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3z"/><path d="m7 16.5-4.74-2.85"/><path d="m7 16.5 5-3"/><path d="M7 16.5v5.17"/><path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3z"/><path d="m17 16.5-5-3"/><path d="m17 16.5 4.74-2.85"/><path d="M17 16.5v5.17"/><path d="M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0z"/><path d="M12 8 7.26 5.15"/><path d="m12 8 4.74-2.85"/><path d="M12 13.5V8"/>',
    'palette': '<circle cx="13.5" cy="6.5" r=".5" fill="currentColor" stroke="none"/><circle cx="17.5" cy="10.5" r=".5" fill="currentColor" stroke="none"/><circle cx="8.5" cy="7.5" r=".5" fill="currentColor" stroke="none"/><circle cx="6.5" cy="12.5" r=".5" fill="currentColor" stroke="none"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>',
    'key': '<path d="m21 2-9.6 9.6"/><circle cx="7.5" cy="15.5" r="5.5"/><path d="m21 2-3.5 3.5"/><path d="m15.5 7.5 3 3L22 7l-3-3"/>',
    'star': '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
    'check': '<polyline points="20 6 9 17 4 12"/>',
    'pin': '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/>',
    'plus': '<path d="M5 12h14"/><path d="M12 5v14"/>',
    'minus': '<path d="M5 12h14"/>',
    'x': '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    'message': '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
    'mail': '<rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>'
  }
  function injectIcons(root){
    var els = (root || document).querySelectorAll('[class*="icon-"]')
    els.forEach(function(el){
      if (el.dataset.iconDone) return
      var cls = Array.from(el.classList).find(function(c){ return c.indexOf('icon-') === 0 })
      if (!cls) return
      var name = cls.replace('icon-', '')
      var svg = ICONS[name]
      if (!svg) return
      el.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">' + svg + '</svg>'
      el.dataset.iconDone = '1'
    })
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ injectIcons() })
  } else {
    injectIcons()
  }
  // Re-inject after any dynamic addition (small util)
  window.__wbInjectIcons = injectIcons
})();

(function(){
  'use strict'

  // ----- Year -----
  var yearEl = document.getElementById('year')
  if (yearEl) yearEl.textContent = new Date().getFullYear()

  // ----- Hero parallax -----
  var heroBg = document.getElementById('heroBg')
  if (heroBg){
    window.addEventListener('scroll', function(){
      var y = Math.min(window.scrollY, 600)
      heroBg.style.transform = 'translateY(' + (y * 0.2) + 'px)'
    }, { passive: true })
  }

  // ----- Reveal on scroll (IntersectionObserver) -----
  var revealEls = document.querySelectorAll('.reveal')
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){
        var el = e.target
        var d = parseFloat(el.dataset.delay || 0)
        setTimeout(function(){ el.classList.add('in') }, d * 1000)
        io.unobserve(el)
      }
    })
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' })
  revealEls.forEach(function(el){ io.observe(el) })

  // ----- Before / After slider -----
  var baWrap = document.getElementById('baWrap')
  var baAfter = document.getElementById('baAfter')
  var baHandle = document.getElementById('baHandle')
  if (baWrap && baAfter && baHandle){
    var dragging = false
    var setPos = function(clientX){
      var rect = baWrap.getBoundingClientRect()
      var p = ((clientX - rect.left) / rect.width) * 100
      p = Math.max(0, Math.min(100, p))
      baAfter.style.width = p + '%'
      baHandle.style.left = p + '%'
    }
    var start = function(){ dragging = true }
    var end = function(){ dragging = false }
    var move = function(e){
      var x = e.touches ? e.touches[0].clientX : e.clientX
      if (dragging || e.type === 'mousemove') setPos(x)
    }
    baWrap.addEventListener('mousedown', start)
    window.addEventListener('mouseup', end)
    window.addEventListener('mousemove', function(e){ if (dragging) setPos(e.clientX) })
    baWrap.addEventListener('mousemove', function(e){ setPos(e.clientX) })
    baWrap.addEventListener('touchstart', start, { passive: true })
    baWrap.addEventListener('touchend', end)
    baWrap.addEventListener('touchmove', move, { passive: true })
  }

  // ----- Animated counters -----
  var counters = document.querySelectorAll('.ac-num')
  var counterObs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return
      var el = e.target
      var target = parseFloat(el.dataset.target || '0')
      var suffix = el.dataset.suffix || ''
      var isFloat = el.classList.contains('float')
      var dur = 1800
      var startT = performance.now()
      var tick = function(now){
        var p = Math.min((now - startT) / dur, 1)
        var v = p * target
        if (isFloat) el.textContent = v.toFixed(1) + suffix
        else el.textContent = Math.floor(v) + suffix
        if (p < 1) requestAnimationFrame(tick)
      }
      requestAnimationFrame(tick)
      counterObs.unobserve(el)
    })
  }, { threshold: 0.5 })
  counters.forEach(function(el){ counterObs.observe(el) })

  // ----- Portfolio filter -----
  var portFilters = document.getElementById('portFilters')
  var masonry = document.getElementById('masonry')
  if (portFilters && masonry){
    portFilters.addEventListener('click', function(e){
      var btn = e.target.closest('.chip')
      if (!btn) return
      portFilters.querySelectorAll('.chip').forEach(function(c){ c.classList.remove('active') })
      btn.classList.add('active')
      var filter = btn.dataset.filter
      masonry.querySelectorAll('.mas-item').forEach(function(item){
        var show = filter === 'all' || item.dataset.cat === filter
        item.style.display = show ? '' : 'none'
      })
    })
  }

  // ================= MODAL POPUP =================
  function getModal() {
    return document.getElementById('modal');
  }
  function getLeadForm() {
    return document.getElementById('leadForm');
  }

  function openModal(){
    var m = getModal();
    if (!m) {
      var cta = document.getElementById('cta') || document.querySelector('.cta') || document.querySelector('.wbh-cta');
      if (cta) cta.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    m.classList.add('open');
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){
      var first = m.querySelector('.step.active input, .step.active select');
      if (first) first.focus();
    }, 300);
  }

  function closeModal(){
    var m = getModal();
    if (!m) return;
    m.classList.remove('open');
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function goToStep(n){
    var m = getModal();
    if (!m) return;
    var progress = m.querySelectorAll('.mp');
    m.querySelectorAll('.step').forEach(function(s){ s.classList.remove('active'); });
    var target = m.querySelector('.step-' + n);
    if (target) target.classList.add('active');
    progress.forEach(function(el, idx){
      if (idx < n) el.classList.add('mp-active');
      else el.classList.remove('mp-active');
    });
  }

  // Open modal on any CTA
  document.addEventListener('click', function(e){
    var opener = e.target.closest('.js-open-modal');
    if (opener){
      e.preventDefault();
      openModal();
      return;
    }
    var closer = e.target.closest('.js-close-modal');
    if (closer){
      e.preventDefault();
      closeModal();
      return;
    }
    var nextBtn = e.target.closest('.js-next');
    if (nextBtn){
      var f = getLeadForm();
      if (!f) return;
      var nameEl = f.querySelector('[name="name"]');
      var phoneEl = f.querySelector('[name="phone"]');
      if (!nameEl.value.trim()){ nameEl.focus(); nameEl.style.borderColor = '#e11'; return; }
      if (!phoneEl.value.trim() || phoneEl.value.trim().length < 6){ phoneEl.focus(); phoneEl.style.borderColor = '#e11'; return; }
      nameEl.style.borderColor = ''; phoneEl.style.borderColor = '';
      goToStep(parseInt(nextBtn.dataset.next || '2', 10));
      return;
    }
    var backBtn = e.target.closest('.js-back');
    if (backBtn){
      goToStep(parseInt(backBtn.dataset.back || '1', 10));
      return;
    }
  });

  // ESC key closes modal
  document.addEventListener('keydown', function(e){
    var m = getModal();
    if (e.key === 'Escape' && m && m.classList.contains('open')) closeModal();
  });

  // Submit form to Abhishek.sahu@ixdesigns.in via formsubmit.co AJAX (Delegated)
  document.addEventListener('submit', function(e){
    if (e.target && e.target.id === 'leadForm'){
      e.preventDefault();
      var f = e.target;
      var submitBtn = document.getElementById('submitBtn') || f.querySelector('[type="submit"]');
      var data = {
        name: f.name ? f.name.value.trim() : '',
        phone: f.phone ? f.phone.value.trim() : '',
        city: f.city ? f.city.value : '',
        propertyType: f.propertyType ? f.propertyType.value : '',
        budget: f.budget ? f.budget.value : '',
        message: f.message ? f.message.value.trim() : '',
        _subject: 'New Home Interior Custom Consultation Request'
      };
      if (!data.name || !data.phone){
        alert('Please fill your name and phone.');
        return;
      }
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Booking...';
      }
      fetch('https://formsubmit.co/ajax/Abhishek.sahu@ixdesigns.in', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function(res){
        return res.json().catch(function(){ return { success: res.ok }; });
      })
      .then(function(j){
        if (j.success === "true" || j.success === true){
          goToStep(3);
          f.reset();
        } else {
          alert('Something went wrong. Please try again or call us at +91 99901 98889.');
        }
      })
      .catch(function(err){
        alert('Network error. Please try again.');
      })
      .finally(function(){
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
    }
  });


  // ----- Exit-intent popup (once per session) -----
  var exitShown = sessionStorage.getItem('wb_exit') === '1'
  if (!exitShown){
    var handler = function(e){
      var m = getModal();
      if (e.clientY < 8 && m && !m.classList.contains('open')){
        sessionStorage.setItem('wb_exit', '1')
        openModal()
        document.removeEventListener('mouseleave', handler)
      }
    }
    document.addEventListener('mouseleave', handler)
  }
})();

var galleryImages = window.galleryImages || {
  living:[
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80"
  ],
  kitchen:[
    "https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=900&q=80"
  ],
  bedroom:[
    "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=900&q=80"
  ],
  wardrobe:[],
  dining:[],
  tv:[],
  office:[],
  ceiling:[]
};

window.openGallery = function(title,key){
  document.getElementById("galleryTitle").innerText=title;
  const grid=document.getElementById("galleryGrid");
  grid.innerHTML="";
  if (galleryImages[key] && galleryImages[key].length > 0) {
    galleryImages[key].forEach(img=>{
      grid.innerHTML+=`<img src="${img}" alt="">`;
    });
  } else {
    grid.innerHTML="<p class='text-walnut/60 text-sm'>Gallery photos coming soon.</p>";
  }
  document.getElementById("galleryModal").classList.add("show");
};

window.closeGallery = function(){
  document.getElementById("galleryModal").classList.remove("show");
};

window.onclick=function(e){
  const modal=document.getElementById("galleryModal");
  if(e.target==modal){
    window.closeGallery();
  }
};
